<template>
  <div class="list-help">
    <h3>Hướng dẫn sử dụng</h3>
    <div v-if="level === 'STORE'">
      <label>Thêm nhân viên phụ</label>
      <ul>
        <li>
          Nhân viên chăm sóc chính của cửa hàng mặc định được gán là nhân viên chăm sóc chính của
          MA.
        </li>
        <li>
          Danh sách nhân viên được chọn gán tại cửa hàng mặc định là nhân viên chăm sóc phụ của cửa
          hàng
        </li>
      </ul>
    </div>
    <div v-else>
      <label class="font-bold">Thêm nhân viên chính</label>
      <ul>
        <li>Tích để chọn nhân viên chính. Mỗi lần gán chỉ được gán 01 nhân viên chính</li>
        <li>Danh sách đã chọn không được tích sẽ là nhân viên phụ</li>
        <li>Tích chọn lại lần 2 để bỏ chọn nhân viên chính</li>
      </ul>
      <label class="font-bold">Chú thích:</label>
      <br />
      <img class="mr-1 ml-1" src="@/assets/img/warning.svg" alt="warning-icon" />
      <span>Merchant được gán cho nhân viên chăm sóc khác</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      level: {
        type: String,
        default: null,
      },
    },
  }
</script>

<style lang="scss" scoped>
  .list-help {
    border: 1px solid #dcdcdc;
    border-radius: 12px;
    padding: 12px;
    margin-right: 10px;

    h3 {
      font-size: 14px;
      text-transform: uppercase;
      margin-bottom: 15px !important;
      font-weight: normal !important;
    }
    label {
      font-weight: 600;
    }

    ul {
      margin-left: 15px;
      margin-bottom: 17px;
      li {
        font-size: 12px;
        list-style: disc;
        label {
          font-weight: 600;
        }
      }
    }
  }
</style>
